module.exports = __webpack_public_path__ + "img/qianzifw_img.32464bab.png";